import { MODEL as MODEL_MATERIAL } from '_modules/material/components/MaterialModel';

export const _LOAD_MODEL_ = 'Load:ProductModel';
export const _LOAD_TYPE_MODEL_ = 'Load:ProductVariationTypeModel';
export const _LOAD_TYPE_OPTION_MODEL_ = 'Load:ProductVariationTypeOptionModel';

export const _DELETE_PRODUCT_ = 'Delete:Product';
export const _DELETE_PRODUCT_TYPE_ = 'Delete:ProductType';
export const _DELETE_PRODUCT_OPTION_ = 'Delete:ProductOption';
export const _DELETE_PRODUCT_VARIATION_ = 'Delete:ProductVariation';

export const _SAVE_PRODUCT_SUCCESS_ = 'Save:ProductSuccess';

export const _RELOAD_VARIATION_ = 'Reload:VariationType';

export const _FINISHED_SAVE_REQUEST_ = 'SaveRequest:Finished';

export const PRODUCT_UNITS_OPTIONS = [
  { id: null, name: null, description: '' },
];

export const MODEL_TYPE_OPTION = {
  id: null,
  name: null,
};

export const MODEL_TYPE = {
  id: null,
  name: null,
  values: [
    { id: null, name: null },
  ],
};

export const MATERIAL_ROW = {
  name: null,
  quantity: 0,
  unit_type_id: null,
  unit_type: PRODUCT_UNITS_OPTIONS,
  pivot: {
    quantity: 0,
  },
};

export const MODEL_VARIATION = {
  id: null,
  name: null,
  code: null,
  price: null,
  barcode: null,
  warranty: null,
  warranty_period: null,
  warranty_type: null,
  available: 1,
  created_at: null,
  deleted_at: null,
  product_id: null,
  updated_at: null,
  contract_clause: null,
  show_presentation: 0,
  variation_type_options: [],
  image: { id: null, name: null, url: null },
};

export const MODEL = {
  id: null,
  name: '',
  brand: '',
  description: '',
  variation_id: '',
  unit_type_id: null,
  main_variation: {
    code: '',
    price: '',
    barcode: '',
    product_id: null,
    max_quantity: '',
  },
  materials: [{ ...MODEL_MATERIAL }],
  variations: [{ ...MODEL_VARIATION }],
};
